import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ContactTypeSwitcherWrapper = styled.div`
  margin-top: -${Spacing.S8};
  margin-left: ${Spacing.S16};
`
